import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{questionnaireTemplateId}/field-templates/order']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const reorderFieldQuestionnaire = async ({ questionnaireTemplateId, order }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{questionnaireTemplateId}/field-templates/order', { questionnaireTemplateId });
  const data = await formsBackendClient.put(path, { order });
  return data.data;
};

export default reorderFieldQuestionnaire;
